import script from "./AcmePage.vue?vue&type=script&setup=true&lang=js"
export * from "./AcmePage.vue?vue&type=script&setup=true&lang=js"

import "./AcmePage.vue?vue&type=style&index=0&id=79e20458&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79e20458"]])

export default __exports__